import Navbar from "@/components/feature/Navbar";
import HeroSection from "./components/HeroSection";
import CategoryGrid from "./components/CategoryGrid";
import AboutSection from "./components/AboutSection";
import ArticleGrid from "./components/ArticleGrid";
import CTASection from "./components/CTASection";
import TestimonialSection from "./components/TestimonialSection";
import Footer from "./components/Footer";

const siteUrl = import.meta.env.VITE_SITE_URL || "https://acbuyspreadsheet.blog";

const websiteLD = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": "acbuyspreadsheet",
  "url": siteUrl,
  "description": "The ultimate spreadsheet system for smarter buying and management.",
  "potentialAction": {
    "@type": "SearchAction",
    "target": `${siteUrl}/search?q={search_term_string}`,
    "query-input": "required name=search_term_string",
  },
};

const webpageLD = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  "name": "acbuyspreadsheet – The Ultimate Spreadsheet System for Smarter Buying & Management",
  "url": siteUrl,
  "description": "Discover how acbuyspreadsheet helps users compare, analyze, and optimize spreadsheet workflows with clarity, speed, and automation. Complete 2026 guide covering acbuyspreadsheet tools, comparisons, and buying strategies.",
  "isPartOf": {
    "@type": "WebSite",
    "name": "acbuyspreadsheet",
    "url": siteUrl,
  },
  "about": {
    "@type": "Thing",
    "name": "acbuyspreadsheet",
    "description": "A powerful spreadsheet-based system for smarter buying and product comparison across multiple categories.",
  },
};

export default function Home() {
  return (
    <main>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteLD) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(webpageLD) }}
      />
      <Navbar />
      <HeroSection />
      <CategoryGrid />
      <AboutSection />
      <ArticleGrid />
      <CTASection />
      <TestimonialSection />
      <Footer />
    </main>
  );
}